
import * as React from 'react';
import { ActivityItem, Icon, Link } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/merge-styles';
import { useState } from 'react';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';

const classNames = mergeStyleSets({
    exampleRoot: {
        paddingBottom: '20px',
    },
    nameText: {
        fontWeight: 'bold',
    },
});

export interface AnnotazioniProps {
    extraCssClass?: string
}

const Annotazioni: React.FunctionComponent<AnnotazioniProps> = (props) => {

    const [loading, setLoading] = useState(false);

    const activityItemExamples = [
        {
            key: 1,
            activityDescription: [
                <Link
                    key={1}
                    className={classNames.nameText}

                >
                    Stefano Capone
                </Link>,
            ],
            activityIcon: <Icon iconName={'Message'} />,
            timeStamp: 'Pochi minuti fa',
            comments: [
                <span key={1}>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</span>,

            ],
        },
        {
            key: 2,
            activityDescription: [
                <Link
                    key={1}
                    className={classNames.nameText}

                >
                    Vincenzo Arcella
                </Link>,
            ],
            activityIcon: <Icon iconName={'Message'} />,
            timeStamp: '28/12/2020 16:31',
            comments: [
                <span key={1}>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</span>,

            ],
        },
    ];

    return (
        <div className={`storia flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={`position-relative my-scroll-div`}>
                <div className={`my-component-content`}>

                    {activityItemExamples.map((item: { key: string | number }) => (
                        <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
                    ))}

                </div>

            </div>

        </ div>
    );
};


export default Annotazioni;





